'use strict';

var React = require('react');

var SvgCapitalFilledMajor = function SvgCapitalFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.749 11.957c2.545-.294 4.501-2.066 4.501-4.207 0-2.347-2.35-4.25-5.25-4.25s-5.25 1.903-5.25 4.25c0 2.141 1.956 3.913 4.501 4.207a.763.763 0 0 0-.001.043v4.25a.75.75 0 0 0 1.5 0v-4.25l-.001-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5c-.446 0-.872.083-1.265.235a3.5 3.5 0 0 0 4.53 4.53 3.5 3.5 0 0 0-3.265-4.765Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5c.446 0 .872.083 1.265.235a3.5 3.5 0 0 1-4.53 4.53 3.5 3.5 0 0 1 3.265-4.765Z"
  }));
};
SvgCapitalFilledMajor.displayName = "CapitalFilledMajor";

exports.SvgCapitalFilledMajor = SvgCapitalFilledMajor;
